'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" fillRule="evenodd" d="M5.985 3.36A1 1 0 0 1 6.753 3H17.2a1 1 0 0 1 .765.355l4.8 5.695a1 1 0 0 1-.001 1.29L12.788 22.15a1 1 0 0 1-1.527.002L1.238 10.34a1 1 0 0 1-.006-1.288zM7.221 5 3.72 9.194h3.817L10.657 5zm4.682 0h.235l3.085 4.194h-6.44zm-4.466 5.194H3.736l6.428 7.575zm4.573 9.75-3.51-9.75h7.003l-3.472 9.753-.01.011zm1.856-2.169 6.403-7.58h-3.704zm2.599-8.58h3.806L16.735 5H13.38z" clipRule="evenodd" /></svg>;
const IconDiamond = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconDiamond;